import { SpinnerService } from './../../../../services/shared/spinner.service';
import { Component, OnInit } from '@angular/core';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-webinar',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinar.component.scss']
})
export class WebinarComponent implements OnInit {

  webinarsData: any[] = [];
  specialties: any[] = [];
  sponsors: any[] = [];
  doctors: any[] = [];
  viewMoreUpcomingToggle: boolean = true;
  viewMoreArchivedToggle: boolean = true;
  upcomingWebinars: any[] = [];
  sponsoredWebinars: any[] = [];
  archivedWebinars: any[] = [];
  specialityViewAll: number = 0;
  sponsorViewAll: number = 0;
  doctorViewAll: number = 0;
  loading: boolean = false;
  isFilterExpanded: boolean=false;
  size: any = {
    specialitiesU: 3,
    sponsorsU: 3,
    doctorsU: 3,
    specialitiesA: 3,
    sponsorsA: 3,
    doctorsA: 3,
  }
  webinars: any;
  filteredData: any = {
    upcoming: {
      orgName: [],
      speakersName: [],
      speciality: []
    },
    archived: {
      orgName: [],
      speakersName: [],
      speciality: []
    }
  };
  isMobileView: boolean = false;
  isSpecialtiesOpen: boolean = false;
  isSpecialtiesOpenArchived: boolean = false;
  isSponsorsOpen: boolean = false;
  isSponsorsOpenArchived: boolean = false;
  isDoctorsOpen: boolean = false;
  isDoctorsOpenArchived: boolean = false;

  originalTruncateText: number = 24;

  filteredParams: { orgName: any[], speakersName: any[], speciality: any[] } = {
    orgName: [],
    speakersName: [],
    speciality: []
  };

  constructor(private webinarService: WebinarService, private router: Router, private breakpointObserver: BreakpointObserver,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    this.getDoctorNames();
    this.getSponsorNames();
    this.getSpeciality();
    this.filters(this.filteredParams);
    this.showAllBreakPoints();
  }

  getDoctorNames() {
    this.webinarService.getSpeakers().subscribe((res: any) => {
      res.data.map((s: any) => {
        this.doctors.push(s.speakersName);
      });
    });
  }

  getSponsorNames() {
    this.webinarService.getSponsors().subscribe((res: any) => {
      res.data.map((s: any) => {
        this.sponsors.push(s.orgName);
      });
    });
  }

  getSpeciality(pageNumber: number = 0, pageSize: number = 100) {
    this.webinarService.getSpeciality(pageNumber, pageSize).subscribe((data: any) => {
      if (data && data.data) {
        const specialties = data.data.map((spec: any) => spec.specialty);
        this.specialties.push(...specialties);
        this.specialties.sort();
        if (data.data.length === pageSize) {
          this.getSpeciality(pageNumber + 1, pageSize);
        }
      }
    });
  }

  filters(filteredData: any) {
    this.spinnerService.showSpinner();
    this.webinarService.filters(filteredData).subscribe((res: any) => {
      this.webinars = res.data;

      this.splitWebinars();

    this.spinnerService.hideSpinner();
    const sponsorsData = Array.from(new Set(this.webinars.map((card: any) => card.orgName))).sort();
    const doctorsData = Array.from(new Set(this.webinars.map((card: any) => card.speakersName[0]))).sort();
    this.sponsors = sponsorsData;
    this.doctors = doctorsData;
    });

  }

  nulls: any = new Set([null, 'null', undefined, 'undefined', '', 'N/A']);

  splitWebinars() {
    this.upcomingWebinars = [];
    this.archivedWebinars = [];
    const currentDateTime = new Date();
    this.webinars.forEach((webinar: any) => {
      if (!this.nulls.has(webinar.webinarDate)) {
        const time = this.nulls.has(webinar?.webinarTime) ? '23:59:59' : webinar?.webinarTime;
        const webinarDateTimeStr = `${webinar?.webinarDate} ${time}`;
        const webinarDateTime = new Date(webinarDateTimeStr);
        if (webinarDateTime > currentDateTime) {
          this.upcomingWebinars.push(webinar);
        } else {
          this.archivedWebinars.push(webinar);
        }
      } else {
        this.upcomingWebinars.push(webinar);
      }
    });
    this.upcomingWebinars.sort((a, b) => {
      if (a.sponsored !== b.sponsored) {
        return a.sponsored ? -1 : 1;
      }
      const aHasNoDate = this.nulls.has(a.webinarDate);
      const bHasNoDate = this.nulls.has(b.webinarDate);
      if (aHasNoDate !== bHasNoDate) {
        return aHasNoDate ? -1 : 1;
      }
      if (!aHasNoDate && !bHasNoDate) {
        return this.compareDateTime(a, b);
      }
      return 0;
    });
    this.archivedWebinars.sort((a, b) => {
      if (a.sponsored !== b.sponsored) {
        return a.sponsored ? -1 : 1;
      }
      return this.compareDateTime(b, a);
    });
  }
  isUpcoming(card: any, currentDateTime: Date): boolean {
    const webinarDateTime = new Date(card.webinarDate);
    const webinarTime = this.parseTime(card.webinarTime);
    if(!card.webinarDate || !card.webinarTime){
      return true;
    }
    webinarDateTime.setHours(Math.floor(webinarTime / 60), webinarTime % 60, 0, 0);

    
    return webinarDateTime >= currentDateTime;
  }

  compareDateTime(a: any, b: any): number {
    const dateA = new Date(a.webinarDate);
    const dateB = new Date(b.webinarDate);
    
    if (dateA.getTime() !== dateB.getTime()) {
      return dateA.getTime() - dateB.getTime();
    }
    const timeA = this.parseTime(a.webinarTime);
    const timeB = this.parseTime(b.webinarTime);
      return timeA - timeB;
  }

  parseTime(time: string): number {
    if (!time) return 0;
    const [hours, minutesPart] = time.split(':');
    const [minutes, period] = minutesPart?.split(' ') ?? [];
    let totalMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  
    if (period?.toUpperCase() === 'PM' && parseInt(hours, 10) !== 12) {
      totalMinutes += 12 * 60;
    } else if (period?.toUpperCase() === 'AM' && parseInt(hours, 10) === 12) {
      totalMinutes -= 12 * 60;
    }
  
    return totalMinutes;
  }
  specialtiesViewAll(type: string, action: boolean) {
    switch (type) {
      case 'upcoming':
        if(action){
          this.specialityViewAll = 1;
          this.size.specialitiesU = this.specialties.length;
        }
        else{
          this.specialityViewAll = 0;
          this.size.specialitiesU = 3;
        }
        break;
      
      case 'archived':
        if(action){
          this.specialityViewAll = 1;
          this.size.specialitiesA = this.specialties.length;
        }
        else{
          this.specialityViewAll = 0;
          this.size.specialitiesA = 3;
        }
        break;
    
      default:
        break;
    }
  }

  sponsorsViewAll(type: string, action: boolean) {
    switch (type) {
      case 'upcoming':
        if(action){
          this.sponsorViewAll = 1;
          this.size.sponsorsU = this.sponsors.length;
        }
        else{
          this.sponsorViewAll = 0;
          this.size.sponsorsU = 3;
        }
        break;
      case 'archived':
        if(action){
          this.sponsorViewAll = 1;
          this.size.sponsorsA = this.sponsors.length;
        }
        else{
          this.sponsorViewAll = 0;
          this.size.sponsorsA = 3;
        }
        break;
      default:
        break;
    }
  }

  doctorsViewAll(type: string, action: boolean) {
    switch (type) {
      case 'upcoming':
        if(action){
          this.doctorViewAll = 1;
          this.size.doctorsU = this.doctors.length;
        }
        else{
          this.doctorViewAll = 0;
          this.size.doctorsU = 3;
        }
        break;
      case 'archived':
        if(action){
          this.doctorViewAll = 1;
          this.size.doctorsA = this.doctors.length;
        }
        else{
          this.doctorViewAll = 0;
          this.size.doctorsA = 3;
        }
        break;
      default:
        break;
    }
  }

  sponsorSelected(event: any, item: any, type: string) {
    this.loading = false;
    if (type === 'archived') {
      this.updateFilter(event.checked, item, 'archived', 'orgName');
      this.filterWebinars('archived');
    } else if (type === 'specialty') {
      this.updateFilter(event.checked, item, 'upcoming', 'orgName');
      this.filterWebinars('upcoming');
    }
   
  }

  specialtySelected(event: any, item: any, type: string) {
    this.loading = false;
    if (type === 'archived') {
      this.updateFilter(event.checked, item, 'archived', 'speciality');
      this.filterWebinars('archived');
    } else if (type === 'specialty') {
      this.updateFilter(event.checked, item, 'upcoming', 'speciality');
      this.filterWebinars('upcoming');
    }
   
  }

  doctorSelected(event: any, item: any, type: string) {
    this.loading = false;
    if (type === 'archived') {
      this.updateFilter(event.checked, item, 'archived', 'speakersName');
      this.filterWebinars('archived');
    } else if (type === 'upcoming') {
      this.updateFilter(event.checked, item, 'upcoming', 'speakersName');
      this.filterWebinars('upcoming');
    }
      
  }

  updateFilter(isChecked: boolean, item: any, category: string, key: string) {
    if (isChecked) {
      this.filteredData[category][key].push(item);
    } else {
      const index = this.filteredData[category][key].indexOf(item);
      if (index > -1) {
        this.filteredData[category][key].splice(index, 1);
      }
    }
  }
  filterWebinars(category: string) {
    if (category === 'archived') {
      let filtered = this.webinars
        .filter((card: any) => {
          if (this.nulls.has(card.webinarDate) || this.nulls.has(card.webinarTime)) {
            return false;
          }
          const webinarDateTime = new Date(`${card.webinarDate} ${card.webinarTime}`);
          return webinarDateTime < new Date();
        })
        .filter((card: any) =>
          (this.filteredData.archived.orgName.length === 0 ||
            this.filteredData.archived.orgName.includes(card.orgName)) &&
          (this.filteredData.archived.speciality.length === 0 ||
            this.filteredData.archived.speciality.includes(card.speciality)) &&
          (this.filteredData.archived.speakersName.length === 0 ||
            this.filteredData.archived.speakersName.some((name: string) => card.speakersName.includes(name)))
        );
      filtered.sort((a:any, b:any) => {
        if (a.sponsored !== b.sponsored) {
          return a.sponsored ? -1 : 1;
        }
        return this.compareDateTime(b, a);
      });
      
      this.archivedWebinars = filtered;
      
    } else if (category === 'upcoming') {
      let filtered = this.webinars
        .filter((card: any) => {
          if (this.nulls.has(card.webinarDate) || this.nulls.has(card.webinarTime)) {
            return true;
          }
          const webinarDateTime = new Date(`${card.webinarDate} ${card.webinarTime}`);
          return webinarDateTime >= new Date();
        })
        .filter((card: any) =>
          (this.filteredData.upcoming.orgName.length === 0 ||
            this.filteredData.upcoming.orgName.includes(card.orgName)) &&
          (this.filteredData.upcoming.speciality.length === 0 ||
            this.filteredData.upcoming.speciality.includes(card.speciality)) &&
          (this.filteredData.upcoming.speakersName.length === 0 ||
            this.filteredData.upcoming.speakersName.some((name: string) => card.speakersName.includes(name)))
        );
      filtered.sort((a:any, b:any) => {
        if (a.sponsored !== b.sponsored) {
          return a.sponsored ? -1 : 1;
        }
        const aHasNoDate = this.nulls.has(a.webinarDate) || this.nulls.has(a.webinarTime);
        const bHasNoDate = this.nulls.has(b.webinarDate) || this.nulls.has(b.webinarTime);
        
        if (aHasNoDate !== bHasNoDate) {
          return aHasNoDate ? -1 : 1;
        }
        if (!aHasNoDate && !bHasNoDate) {
          return this.compareDateTime(a, b);
        }
        
        return 0;
      });
      
      this.upcomingWebinars = filtered;
    }
  }
  view(id: any, isSponsored: boolean) {
    if(isSponsored) {
      this.router.navigate(['/webinars/view', id],{state: {isSponsored: isSponsored}});
    } else {
      this.router.navigate(['/webinars/view', id]);
    }
  }

  viewMore(type: string) {
    switch (type) {
      case 'upcoming':
        this.viewMoreUpcomingToggle = false;
        break;
      
      case 'archived':
        this.viewMoreArchivedToggle = false;
        break;

    }
  }
  archivedLength: number = 6;
  upcomingLength: number = 6;
toggleView(type: string): void {
  switch (type) {
    case 'archived':
      this.archivedLength = this.archivedLength === 6 ? this.archivedWebinars?.length : 6;
      this.viewMoreArchivedToggle = !this.viewMoreArchivedToggle;
      break;

    case 'upcoming':
      this.upcomingLength = this.upcomingLength === 6 ? this.upcomingWebinars?.length : 6;
      this.viewMoreUpcomingToggle = !this.viewMoreUpcomingToggle;
      break;
  }
}

  showAllBreakPoints() {
    this.breakpointObserver.observe([
      "(min-width: 1540px)",
      "(max-width: 1540px)",
      "(min-width: 1302px) and (max-width: 1390px)",
      "(max-width: 575.98px)",
      "(min-width: 576px)"
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints["(min-width: 1540px)"]) {
          this.originalTruncateText = 100;
        }
        else if (result.breakpoints["(max-width: 1540px)"]) {
          this.originalTruncateText = 70;
        }
        else if (result.breakpoints["(min-width: 1302px) and (max-width: 1390px)"]) {
          this.originalTruncateText = 20;
        }
        else if (result.breakpoints["(max-width: 575.98px)"]) {
          this.isMobileView = true;
          this.isDoctorsOpen = false;
          this.isSpecialtiesOpen = false;
          this.isSponsorsOpen = false;
          this.isSpecialtiesOpenArchived = false;
          this.isSponsorsOpenArchived = false;
          this.isDoctorsOpenArchived = false;
        } else if (result.breakpoints["(min-width: 576px)"]) {
          this.isMobileView = false;
          this.isDoctorsOpen = false;
          this.isSpecialtiesOpen = false;
          this.isSponsorsOpen = false;
          this.isSpecialtiesOpenArchived = false;
          this.isSponsorsOpenArchived = false;
          this.isDoctorsOpenArchived = false;
        }
      }
    });
  }
  
  dropdown(section: string): void {
    if (section === 'specialties') {
      this.isSpecialtiesOpen = !this.isSpecialtiesOpen;
    } else if (section === 'sponsors') {
      this.isSponsorsOpen = !this.isSponsorsOpen;
    } else if (section === 'doctors') {
      this.isDoctorsOpen = !this.isDoctorsOpen;
    }
  }

  dropdownArchived(section: string): void {
    if (section === 'specialties') {
      this.isSpecialtiesOpenArchived = !this.isSpecialtiesOpenArchived;
    } else if (section === 'sponsors') {
      this.isSponsorsOpenArchived = !this.isSponsorsOpenArchived;
    } else if (section === 'doctors') {
      this.isDoctorsOpenArchived = !this.isDoctorsOpenArchived;
    }
  }
  toggleFilter() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }
}